import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IconService {


constructor() {


}

//carGearIcon = environment.angularServer+"/assets/img/icons/car-gear.svg";
//carDoorIcon = environment.angularServer+"/assets/img/icons/car-door.svg";

steeringWheel = environment.angularServer+"/assets/img/icons/steeringWheel.svg";
childSeats = environment.angularServer+"/assets/img/icons/childSeats.svg";
GPSNavigation = environment.angularServer+"/assets/img/icons/GPSNavigation.svg";
additionalService = environment.angularServer+"/assets/img/icons/additionalService.svg";
timeIcon = environment.angularServer+"/assets/img/icons/time.svg";
supplierMapIcon = environment.angularServer+"/assets/img/icons/supplier-map-icon.svg";

lateReturn = environment.angularServer+"/assets/img/icons/late-return.svg";
rentalContractExtension = environment.angularServer+"/assets/img/icons/rental-contract-extension.svg";
rentalContractTermination = environment.angularServer+"/assets/img/icons/rental-contract-termination.svg";
rentalReplacement = environment.angularServer+"/assets/img/icons/rental-replacement.svg";

championsIcon = environment.angularServer+"/assets/img/icons/champions-icon.svg";
bookingIcon = environment.angularServer+"/assets/img/icons/booking-icon.svg";
paymentIcon = environment.angularServer+"/assets/img/icons/payment-icon.svg";

noAvailableRental = environment.angularServer+"/assets/img/icons/car-noavailable.svg";

}
